var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-header'),_vm._v(" "),_c('v-sidebar'),_vm._v(" "),_c('div',{staticClass:"content-box",class:{ 'content-collapse': _vm.collapse }},[_c('v-tags'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.tagsList}},[_c(Component,{tag:"component"})],1)],1)]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d48c54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = cV+h
// module chunks = 16